import Vue from 'vue';
import {
  formatNumber,
  alignForNumber,
  getNodeChildDetails,
  addGroupingInResponseData,
  LinkCellRenderer,
  autoResize,
  countRowsRenderer,
  ProgressBarRenderer
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  handlerResponse
} from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    packagesListColumns: [],
    orderItemsListColumns: [],
    packagesList: [],
    orderItems: [],
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      getNodeChildDetails: getNodeChildDetails,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        cellStyle(params) {
          return alignForNumber(params.value);
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
    packagesGridName: '',
    orderItemsGridName: ''
  },
  getters: {
    packagesListGridOptions(state) {
      return {
        ...state.gridOptions,
        groupSelectsChildren: true,
        components: {
          "AcceptanceLink": LinkCellRenderer('acceptance_id', '/operation/'),
          'SupplierLink': LinkCellRenderer('supplier_id', '/partners/'),
          'PurchaseOrderLink': LinkCellRenderer('po_id', '/purchaseOrders/'),
        }
      };
    },
    orderItemsListGridOptions(state) {
      return {
        ...state.gridOptions,
        components: {
          'SupplierLink': LinkCellRenderer('supplier_id', '/partners/'),
          'PurchaseOrderLink': LinkCellRenderer('po_id', '/purchaseOrders/'),
          'packagesCount': countRowsRenderer('poi_packages'),
          'ProgressBar': ProgressBarRenderer()
        },
        defaultColDef: {
          sortable: true,
          filter: true,
          resizable: true,
          valueFormatter(params) {
            return formatNumber(params.value);
          }
        }
      }
    }
  },
  mutations: {
    setGridData(state, data) {
      state.packagesList =  addGroupingInResponseData(data.packages.data);
      state.orderItems = addGroupingInResponseData(data.pois.data);
      state.orderItemsListColumns = addColIdToColumns(data.pois.used_columns);
      state.packagesListColumns = addColIdToColumns(data.packages.used_columns);
      state.packagesGridName = data.packages.grid_name;
      state.orderItemsGridName = data.pois.grid_name;
    }
  },
  actions: {
    async loadGridData(store, payLoad) {
      try {
        const data = await Vue.http.get('purchase/bind_package/', {params: payLoad}).then(handlerResponse)
        store.commit('setGridData', data);
      } catch (exception) {
        console.log(exception)
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/purchases/binding/packagesBinding.js